import {
  ContentApi,
  type ContentType,
  type CreateContentRoleAssignmentRequest,
  type UpdateContentRoleAssignmentRequest,
  type ContentRoleAssignmentResponse,
  type ContentRoleAssignmentListResponse
} from 'we-tree-api-client/v2';

import { getApiConfiguration } from '@/services/SessionService';
import { ApiResult, withApiSetup } from './apiWrapper';

export type {
  ContentType,
  CreateContentRoleAssignmentRequest,
  UpdateContentRoleAssignmentRequest,
  ContentRoleAssignmentResponse,
  ContentRoleAssignmentListResponse
};

class WrappedContentRolesApi {
  async list(
    familyId: string,
    contentType: string,
    contentId: string
  ): Promise<ApiResult<ContentRoleAssignmentListResponse>> {
    return withApiSetup(
      (config) => new ContentApi(config),
      getApiConfiguration,
      (api) => api.getContentRoleAssignments(familyId, contentType, contentId)
    );
  }

  async create(
    familyId: string,
    contentType: string,
    contentId: string,
    request: CreateContentRoleAssignmentRequest
  ): Promise<ApiResult<ContentRoleAssignmentResponse>> {
    return withApiSetup(
      (config) => new ContentApi(config),
      getApiConfiguration,
      (api) => api.createContentRoleAssignment(familyId, contentType, contentId, request)
    );
  }

  async update(
    familyId: string,
    contentType: string,
    contentId: string,
    userId: string,
    request: UpdateContentRoleAssignmentRequest
  ): Promise<ApiResult<ContentRoleAssignmentResponse>> {
    return withApiSetup(
      (config) => new ContentApi(config),
      getApiConfiguration,
      (api) => api.updateContentRoleAssignment(familyId, contentType, contentId, userId, request)
    );
  }

  async remove(familyId: string, contentType: string, contentId: string, userId: string): Promise<ApiResult<void>> {
    return withApiSetup(
      (config) => new ContentApi(config),
      getApiConfiguration,
      (api) => api.deleteContentRoleAssignment(familyId, contentType, contentId, userId)
    );
  }
}

export const contentRolesApi = new WrappedContentRolesApi();
export default contentRolesApi;
